import { all, put, takeEvery, select } from 'redux-saga/effects'

import { Types } from './actions'

import Api from './Api/sagas'
import Messaging from './Messaging/sagas'
import Chat from './Chat/sagas'
import Tracking from './Tracking/sagas'
import Forms from '../Forms/sagas'

import {
  ApiCreators,
  ChatCreators,
  CoreCreators,
  FrameCreators,
  FormsCreators,
  MessagingCreators,
  SocketCreators,
  TrackingCreators,
  ControlsCreators,
} from '../actions'

import config from './Config'

import { Messages } from '../Core/Socket'

/**
 * Handles the closing of the chat window. If socket is connected
 * then a message is presented to the user
 */

export function* closeChat() {
  const {
    Chat: { chatId, stage },
    Socket: { socketConnected, hasError, pingResponseError },
  } = yield select()

  if (socketConnected) {
    const endChatMessage = Messages.sendEndStage({ chatId, stage })

    // Send end stage message to websocket
    yield put(SocketCreators.sendSocketMessage(endChatMessage))
    yield put(ChatCreators.resetParticipants())

    if (stage === config.stages.AGENT_CHAT) {
      yield put(TrackingCreators.trackCustomerEndedChat())
    }
  }
  // Reset active control
  yield put(ControlsCreators.setActiveControl('Form'))
  // Close the component unless customer is talking with an agent or bot
  if (
    (stage !== config.stages.AGENT_CHAT && stage !== config.stages.BOT_CHAT) ||
    hasError ||
    !socketConnected ||
    pingResponseError
  ) {
    // Close live chat component
    yield put(CoreCreators.resetApp())
  }
}

/**
 * Handles the reset of the app to the initial state
 */

export function* resetApp() {
  yield put(TrackingCreators.trackEndChatWindow())
  yield put(FrameCreators.toggleActive(false))
  yield put(MessagingCreators.clearMessages())
  yield put(FormsCreators.clearForms())
  yield put(ApiCreators.resetApi())
  yield put(SocketCreators.resetWebSocket())
  yield put(ChatCreators.resetChatInfo())
  yield put(ControlsCreators.setActiveControl('Form'))
  yield put(ControlsCreators.setComplexStage(false))
}

export const Core = [takeEvery(Types.CLOSE_CHAT, closeChat), takeEvery(Types.RESET_APP, resetApp)]

export default function* rootSaga() {
  yield all([...Api, ...Core, ...Messaging, ...Tracking, ...Forms, ...Chat])
}
